// src/pages/Consultancy.jsx
import React from "react";
import ConsultancySection from "../homeComponents/home/ConsultancySection";

const Consultancy = () => (
  <section className="pb-24 md:pb-16">
    <ConsultancySection />
  </section>
);

export default Consultancy;